import React, {useState} from "react";
import {useDispatch} from "react-redux";
import { Link, NavLink } from "react-router-dom";

function Footer() {

    //const [sessionStorage,setStorage]=useState();
   // const dispatch = useDispatch();

    return (
        <footer className="bg-custom-green text-white py-16 font-script">
            <div className="max-w-7xl mx-auto px-6">

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    <div>
                        <h3 className="text-2xl font-serif mb-4">Rotheras.gr</h3>
                        <p className="text-gray-300">
                            Handcrafted wicker baskets made in Greece.
                        </p>
                    </div>

                    <div>

                    </div>

                    <div>
                        <h4 className="font-semibold mb-4">Customer Service</h4>
                        <ul className="space-y-2 text-gray-300">
                            <Link className="nav-link" to="/terms">Όροι και Προϋποθέσεις</Link>

                        </ul>
                    </div>

                    <div>
                        <h4 className="font-semibold mb-4">Contact</h4>
                        <p className="text-gray-300">Athens, Greece</p>
                        <p className="text-gray-300">info@rotheras.gr</p>
                    </div>
                </div>

                <div className="border-t border-gray-600 mt-12 pt-8 text-center">
                    <p className="text-gray-300">© 2026 Rotheras.gr. All rights reserved. Καλάθια πλεγμένα με φροντίδα
                        στην Ελλάδα.</p>
                    <br/>
                    <p className="text-stone-100 hover:text-violet-200" >Site Created By<a href="http://nexbytesoftware.com/" target="_blank"
                                                                   className="creator-link">NexByteSoftware</a></p>
                </div>

            </div>
        </footer>
    );
}

export default Footer;